import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckIcon } from 'lucide-react';
export function FinalCTA() {
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const guarantees = ['Sin contratos largos', 'Leads 100% exclusivos', 'Resultados en 30-90 días', 'Garantía de hierro'];
  return <section className="py-24 md:py-32 px-5 md:px-8 bg-carbon border-t border-dark-100 relative overflow-hidden" data-id="element-126">
      {/* Animated Gold Pulse Background */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 blur-[120px] rounded-full pointer-events-none animate-pulse" data-id="element-127" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-129">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gold mb-8 md:mb-10 tracking-tight leading-[1.05] uppercase" data-id="element-130">
            Deja de perseguir leads fríos. Empieza a cerrar transacciones.
          </h2>

          <div className="flex flex-wrap gap-x-6 gap-y-3 justify-center mb-12" data-id="element-131">
            {guarantees.map((item, i) => <div key={i} className="flex items-center gap-2 text-gray-400 text-sm md:text-base font-medium uppercase tracking-wider" data-id="element-132">
                <CheckIcon className="w-5 h-5 text-emerald" data-id="element-133" />
                <span data-id="element-134">{item}</span>
              </div>)}
          </div>

          <div className="w-full sm:w-auto flex flex-col items-center justify-center" data-id="element-135">
            <Button onClick={scrollToContact} className="w-full sm:w-auto !px-10 !py-6 text-base md:text-lg" data-id="element-136">
              QUIERO TRANSACCIONES CALIFICADAS ESTE MES
            </Button>
            <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="mt-6 text-gold/70 text-sm md:text-base underline hover:text-gold transition-colors font-medium tracking-wide" data-id="element-137">
              O agenda directamente →
            </a>
          </div>

          <p className="mt-10 text-gray-500 text-xs md:text-sm font-bold uppercase tracking-widest" data-id="element-138">
            Cupos limitados por zona para garantizar exclusividad de leads.
          </p>
        </motion.div>
      </div>
    </section>;
}